import {enableProdMode} from "@angular/core"
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic"

import {ConfiguratorModule} from "@app/configurator/modules/configurator.module"
import {initializeConsoleApi} from "@common/services/logging"
import {environment} from "environments/environment"
import {loggerFactory} from "@cm/browser-log"
// Side-effect import: registers the mattress template-graph node classes (split out of @cm/template-nodes into @cm/mattress-nodes)
import "@cm/mattress-nodes"

if (environment.production) {
    enableProdMode()
}

// Initialize browser console API for runtime log configuration (cmLog.setLevel(), etc.)
initializeConsoleApi()

const appLogger = loggerFactory.getLogger("app")

const bootstrap = () => platformBrowserDynamic().bootstrapModule(ConfiguratorModule)
bootstrap().catch((err) => appLogger.error(err))
